import * as React from 'react';
import './index.styl';
import { translate, InjectedTranslateProps } from 'react-i18next';
import logo from './logo-red.svg';

export type PageHeaderProps = InjectedTranslateProps & {
  i18nHeader: string;
  i18nSubHeader: string;
};

const PageHeader: React.FunctionComponent<PageHeaderProps> = ({
  t,
  i18nHeader,
  i18nSubHeader,
}) => (
  <div className='page-header'>
    <div className='header'>
      <img src={logo} alt='' className='logo' />
      {t(i18nHeader)}
    </div>
    <div className='sub-header'>{t(i18nSubHeader)}</div>
  </div>
);

export default translate()(PageHeader);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/page-header/index.tsx